export const wordsData = [
  { english: "ask", chinese: "問", emoji: "🙋", category: "normal" },
  { english: "question", chinese: "問題", emoji: "❓", category: "normal" },
  { english: "answer", chinese: "答案", emoji: "✅", category: "normal" },
  { english: "about", chinese: "關於", emoji: "ℹ️", category: "normal" },
  { english: "number", chinese: "數字", emoji: "🔢", category: "normal" },
  { english: "know", chinese: "知道", emoji: "💡", category: "normal" },
  { english: "read", chinese: "讀", emoji: "📖", category: "normal" },
  { english: "feel", chinese: "感覺", emoji: "😊", category: "normal" },
  { english: "draw", chinese: "畫", emoji: "🎨", category: "normal" },
  { english: "write", chinese: "寫", emoji: "✍️", category: "exam" },
  { english: "cute", chinese: "可愛", emoji: "🥰", category: "normal" },
  { english: "doll", chinese: "娃娃", emoji: "🧸", category: "normal" },
  { english: "robot", chinese: "機械人", emoji: "🤖", category: "normal" },
  { english: "make", chinese: "製作", emoji: "🛠️", category: "exam" },
  { english: "place", chinese: "地方", emoji: "📍", category: "normal" },
  { english: "poster", chinese: "海報", emoji: "📜", category: "normal" },
  { english: "rule", chinese: "規則", emoji: "⚖️", category: "normal" },
  { english: "floor", chinese: "地板", emoji: "🚪", category: "normal" },
  { english: "stair", chinese: "樓梯", emoji: "🪜", category: "normal" },
  { english: "wait", chinese: "等待", emoji: "⏳", category: "normal" },
  { english: "picture", chinese: "圖片", emoji: "🖼️", category: "normal" },
  { english: "help", chinese: "幫忙", emoji: "🤝", category: "normal" },
  { english: "use", chinese: "使用", emoji: "🤏", category: "normal" },
  { english: "new", chinese: "新", emoji: "✨", category: "normal" },
  { english: "old", chinese: "舊", emoji: "👴", category: "normal" },
  { english: "favourite", chinese: "最喜愛", emoji: "❤️", category: "normal" },
  { english: "like", chinese: "喜歡", emoji: "👍", category: "normal" },
  { english: "love", chinese: "愛", emoji: "💖", category: "normal" },
  { english: "eat", chinese: "吃", emoji: "🍽️", category: "normal" },
  { english: "drink", chinese: "喝", emoji: "🥤", category: "normal" },
  { english: "juice", chinese: "果汁", emoji: "🧃", category: "normal" },
  { english: "friend", chinese: "朋友", emoji: "🧑‍🤝‍🧑", category: "normal" },
  { english: "idea", chinese: "主意", emoji: "💡", category: "normal" },
  { english: "angry", chinese: "生氣", emoji: "😠", category: "normal" },
  { english: "give", chinese: "給", emoji: "🎁", category: "normal" },
  { english: "get", chinese: "得到", emoji: "✊", category: "normal" },
  { english: "run", chinese: "跑", emoji: "🏃", category: "normal" },
  { english: "take", chinese: "取", emoji: "🖐️", category: "normal" },
  { english: "walk", chinese: "走", emoji: "🚶", category: "normal" },
  { english: "jump", chinese: "跳", emoji: "🤸", category: "normal" },
  { english: "classmate", chinese: "同學", emoji: "👨‍🎓", category: "normal" },
  { english: "teacher", chinese: "老師", emoji: "👨‍🏫", category: "normal" },
  { english: "student", chinese: "學生", emoji: "🧑‍🎓", category: "normal" },
  { english: "school", chinese: "學校", emoji: "🏫", category: "normal" },
  { english: "gift", chinese: "禮物", emoji: "💝", category: "normal" },
  { english: "happy", chinese: "快樂", emoji: "😊", category: "normal" },
  { english: "sad", chinese: "傷心", emoji: "😢", category: "normal" },
  { english: "parent", chinese: "家長", emoji: "👨‍👩‍👧", category: "exam" },
  { english: "bored", chinese: "悶", emoji: "😑", category: "normal" },
  { english: "cut", chinese: "切", emoji: "✂️", category: "normal" },
  { english: "stop", chinese: "停止", emoji: "🛑", category: "normal" },
  { english: "play", chinese: "玩", emoji: "🎮", category: "normal" },
  { english: "watch", chinese: "觀看", emoji: "👀", category: "normal" },
  { english: "close", chinese: "關閉", emoji: "🚪", category: "normal" },
  { english: "wear", chinese: "穿", emoji: "👕", category: "normal" },
  { english: "where", chinese: "哪裡", emoji: "🗺️", category: "exam" },
  { english: "who", chinese: "誰", emoji: "🤔", category: "exam" },
  { english: "when", chinese: "何時", emoji: "🕰️", category: "exam" },
  { english: "why", chinese: "為什麼", emoji: "❓", category: "normal" },
  { english: "how", chinese: "怎樣", emoji: "🤷", category: "exam" },
  { english: "how many", chinese: "幾多", emoji: "🔢", category: "normal" },
  { english: "how old", chinese: "幾歲", emoji: "🎂", category: "normal" },
  { english: "what", chinese: "甚麼", emoji: "❓", category: "exam" },
  { english: "which", chinese: "哪個", emoji: "👉", category: "exam" },
  { english: "spider", chinese: "蜘蛛", emoji: "🕷️", category: "normal" },
  { english: "tiger", chinese: "老虎", emoji: "🐅", category: "normal" },
  { english: "panda", chinese: "熊貓", emoji: "🐼", category: "normal" },
  { english: "lion", chinese: "獅子", emoji: "🦁", category: "normal" },
  { english: "monkey", chinese: "猴子", emoji: "🐒", category: "normal" },
  { english: "hippo", chinese: "河馬", emoji: "🦛", category: "normal" },
  { english: "be", chinese: "是", emoji: "☝️", category: "normal" },
  { english: "have", chinese: "有", emoji: "🙌", category: "normal" },
  { english: "do", chinese: "做", emoji: "👍", category: "normal" },
  { english: "go", chinese: "去", emoji: "🚀", category: "normal" },
  { english: "come", chinese: "來", emoji: "👋", category: "normal" },
  { english: "sit", chinese: "坐", emoji: "🪑", category: "normal" },
  { english: "stand", chinese: "站", emoji: "🧍", category: "normal" },
  { english: "sleep", chinese: "睡覺", emoji: "😴", category: "normal" },
  { english: "sing", chinese: "唱歌", emoji: "🎤", category: "normal" },
  { english: "dance", chinese: "跳舞", emoji: "💃", category: "normal" },
  { english: "look", chinese: "看", emoji: "👀", category: "normal" },
  { english: "see", chinese: "見", emoji: "☝️", category: "normal" },
  { english: "hear", chinese: "聽", emoji: "👂", category: "normal" },
  { english: "want", chinese: "想要", emoji: "😋", category: "normal" },
  { english: "think", chinese: "想", emoji: "🤔", category: "normal" },
  { english: "say", chinese: "說", emoji: "💬", category: "normal" },
  { english: "show", chinese: "展示", emoji: "🙌", category: "normal" },
  { english: "open", chinese: "打開", emoji: "🔓", category: "normal" },
  { english: "pick", chinese: "摘", emoji: "🍓", category: "normal" },
  { english: "catch", chinese: "捉", emoji: "🎣", category: "normal" },
  { english: "throw", chinese: "投", emoji: "🏀", category: "normal" },
  { english: "kick", chinese: "踢", emoji: "⚽", category: "normal" },
  { english: "fly", chinese: "飛", emoji: "✈️", category: "normal" },
  { english: "ride", chinese: "騎", emoji: "🚴", category: "normal" },
  { english: "climb", chinese: "爬", emoji: "🧗", category: "normal" },
  { english: "work", chinese: "工作", emoji: "💼", category: "normal" },
  { english: "wash", chinese: "洗", emoji: "🧼", category: "normal" },
  { english: "brush", chinese: "刷", emoji: "🪥", category: "normal" },
  { english: "dress", chinese: "穿衣", emoji: "👗", category: "normal" },
  { english: "carry", chinese: "攜帶", emoji: "💼", category: "normal" },
  { english: "push", chinese: "推", emoji: "💨", category: "normal" },
  { english: "pull", chinese: "拉", emoji: "🤝", category: "normal" },
  { english: "hold", chinese: "抱", emoji: "🤗", category: "normal" },
  { english: "break", chinese: "破", emoji: "💥", category: "normal" },
  { english: "clean", chinese: "清潔", emoji: "🧹", category: "normal" },
  { english: "count", chinese: "計數", emoji: "🔢", category: "normal" },
  { english: "build", chinese: "建造", emoji: "🏗️", category: "normal" },
  { english: "buy", chinese: "買", emoji: "🛒", category: "normal" },
  { english: "big", chinese: "大", emoji: "📏", category: "normal" },
  { english: "small", chinese: "小", emoji: "🤏", category: "normal" },
  { english: "long", chinese: "長", emoji: "📏", category: "normal" },
  { english: "short", emoji: "短", chinese: "📏", category: "normal" },
  { english: "tall", chinese: "高", emoji: "📏", category: "normal" },
  { english: "red", chinese: "紅", emoji: "🔴", category: "normal" },
  { english: "blue", chinese: "藍", emoji: "🔵", category: "normal" },
  { english: "yellow", chinese: "黃", emoji: "🟡", category: "normal" },
  { english: "green", chinese: "綠", emoji: "🟢", category: "normal" },
  { english: "orange", chinese: "橙", emoji: "🟠", category: "normal" },
  { english: "purple", chinese: "紫", emoji: "🟣", category: "normal" },
  { english: "pink", chinese: "粉紅", emoji: "🩷", category: "normal" },
  { english: "black", chinese: "黑", emoji: "⚫", category: "normal" },
  { english: "white", chinese: "白", emoji: "⚪", category: "normal" },
  { english: "scared", chinese: "害怕", emoji: "😨", category: "normal" },
  { english: "tired", chinese: "疲倦", emoji: "😴", category: "normal" },
  { english: "hungry", chinese: "餓", emoji: "😋", category: "normal" },
  { english: "thirsty", chinese: "渴", emoji: "🥵", category: "normal" },
  { english: "warm", chinese: "溫暖", emoji: "🔥", category: "normal" },
  { english: "cold", chinese: "冷", emoji: "❄️", category: "normal" },
  { english: "hot", chinese: "熱", emoji: "☀️", category: "normal" },
  { english: "good", chinese: "好", emoji: "👍", category: "normal" },
  { english: "bad", chinese: "壞", emoji: "👎", category: "normal" },
  { english: "nice", chinese: "好", emoji: "😊", category: "normal" },
  { english: "pretty", chinese: "漂亮", emoji: "✨", category: "normal" },
  { english: "dirty", chinese: "骯髒", emoji: "🤢", category: "normal" },
  { english: "soft", chinese: "軟", emoji: "☁️", category: "normal" },
  { english: "hard", chinese: "硬", emoji: "💎", category: "normal" },
  { english: "slow", chinese: "慢", emoji: "🐢", category: "normal" },
  { english: "fast", chinese: "快", emoji: "⚡", category: "normal" },
  { english: "now", chinese: "現在", emoji: "🕰️", category: "normal" },
  { english: "today", chinese: "今天", emoji: "📅", category: "exam" },
  { english: "yesterday", chinese: "昨天", emoji: "🗓️", category: "normal" },
  { english: "tomorrow", chinese: "明天", emoji: "📅", category: "normal" },
  { english: "always", chinese: "總是", emoji: "♾️", category: "normal" },
  { english: "never", chinese: "從不", emoji: "🚫", category: "normal" },
  { english: "often", chinese: "經常", emoji: "📈", category: "normal" },
  { english: "early", chinese: "早", emoji: "🌅", category: "normal" },
  { english: "late", chinese: "晚", emoji: "🌃", category: "normal" },
  { english: "here", chinese: "這裡", emoji: "👇", category: "normal" },
  { english: "there", chinese: "那裡", emoji: "👉", category: "normal" },
  { english: "up", chinese: "上", emoji: "⬆️", category: "normal" },
  { english: "down", chinese: "下", emoji: "⬇️", category: "normal" },
  { english: "in", chinese: "裡", emoji: "📥", category: "normal" },
  { english: "out", chinese: "外", emoji: "📤", category: "normal" },
  { english: "inside", chinese: "裡面", emoji: "🏠", category: "normal" },
  { english: "outside", chinese: "外面", emoji: "🌳", category: "normal" },
  { english: "near", chinese: "近", emoji: "📍", category: "normal" },
  { english: "far", chinese: "遠", emoji: "🗺️", category: "normal" },
  { english: "quickly", chinese: "快速", emoji: "💨", category: "normal" },
  { english: "slowly", chinese: "慢", emoji: "🐌", category: "normal" },
  { english: "carefully", chinese: "小心", emoji: "⚠️", category: "normal" },
  { english: "happily", chinese: "快樂地", emoji: "😄", category: "normal" },
  { english: "quietly", chinese: "安靜地", emoji: "🤫", category: "normal" },
  { english: "loudly", chinese: "大聲地", emoji: "📢", category: "normal" },
  { english: "very", chinese: "很", emoji: "📈", category: "normal" },
  { english: "so", chinese: "很", emoji: "💯", category: "normal" },
  { english: "too", chinese: "太", emoji: "⚠️", category: "normal" },
  { english: "also", chinese: "也", emoji: "➕", category: "normal" },
  { english: "only", chinese: "只", emoji: "1️⃣", category: "normal" },
  { english: "line up", chinese: "排隊", emoji: "🧍🧍🧍", category: "normal" },
  { english: "corridor", chinese: "走廊", emoji: "🚶‍♀️", category: "normal" },
  { english: "library", chinese: "圖書館", emoji: "📚", category: "normal" },
  { english: "quiet", chinese: "安靜", emoji: "🤫", category: "normal" },
  { english: "must", chinese: "必須", emoji: "✅", category: "normal" },
  { english: "together", chinese: "一起", emoji: "🤝", category: "normal" },
  { english: "litter", chinese: "垃圾", emoji: "🗑️", category: "normal" },
  { english: "put", chinese: "放", emoji: "➡️", category: "normal" },
  { english: "turn", chinese: "轉", emoji: "↪️", category: "normal" },
  { english: "but", chinese: "但是", emoji: "🤔", category: "exam" },
  { english: "making", chinese: "製作中", emoji: "🛠️", category: "exam" },
  { english: "water", chinese: "水", emoji: "💧", category: "exam" },
  { english: "parents", chinese: "父母", emoji: "👨‍👩‍👧‍👦", category: "exam" },
  { english: "want to", chinese: "想要", emoji: "😋", category: "exam" },
  { english: "writing", chinese: "寫作", emoji: "✍️", category: "exam" },
  { english: "writer", chinese: "作家", emoji: "✍️", category: "exam" },
  { english: "poem", chinese: "詩", emoji: "📜", category: "exam" },
  { english: "rhymes", chinese: "押韻", emoji: "🎶", category: "exam" },
  { english: "because", chinese: "因為", emoji: "❓", category: "exam" },
  { english: "sentence", chinese: "句子", emoji: "📝", category: "exam" },
  { english: "correct", chinese: "正確", emoji: "✅", category: "exam" },
  { english: "incorrect", chinese: "不正確", emoji: "❌", category: "exam" },
  { english: "activities", chinese: "活動", emoji: "🤸", category: "exam" },
  { english: "bring", chinese: "帶來", emoji: "🤝", category: "exam" },
  { english: "word", chinese: "單詞", emoji: "💬", category: "exam" },
  { english: "brother", chinese: "兄弟", emoji: "👦", category: "exam" },
  { english: "sister", chinese: "姐妹", emoji: "👧", category: "exam" },
];
